import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from './Cardano.png';

const Header = () => {
  const [menuAberto, setMenuAberto] = useState(false);

  const fecharMenu = () => setMenuAberto(false);

  return (
    <header className="header">
      <div className="header-logo">
        <Link className="logo" to="/" onClick={fecharMenu}>
          <img src={logo} alt="Logo Cardano Imoveis" />
        </Link>
        <span className="marca">
          <span className="marcaLeve">CARD</span>
          <span className="marcaForte">ANO</span>
          <span className="marcaLeve">IMOVEIS</span>
        </span>
      </div>

      <button
        type="button"
        className="menu-toggle"
        aria-label="Abrir menu"
        aria-expanded={menuAberto}
        onClick={() => setMenuAberto((prev) => !prev)}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className={`header-menu ${menuAberto ? 'aberto' : ''}`}>
        <Link to="/imoveis?tipo_operacao=venda" onClick={fecharMenu}>Compra</Link>
        <Link to="/imoveis?tipo_operacao=locacao" onClick={fecharMenu}>Locação</Link>
        <Link to="/cliente" onClick={fecharMenu}>Área do Cliente</Link>
        <a href="#quem-somos" onClick={fecharMenu}>Quem somos</a>
        <a href="#contato" onClick={fecharMenu}>Entre em contato</a>
      </nav>
    </header>
  );
};

export default Header; 